package nl.volleyplanner.web

import nl.volleyplanner.api.auth.AuthContextService
import nl.volleyplanner.api.auth.AuthLevel
import nl.volleyplanner.web.base.routing.PageRouteContext
import nl.volleyplanner.web.base.routing.RouteGuard
import nl.volleyplanner.web.base.routing.RouteGuardResult
import nl.volleyplanner.web.controller.ForbiddenController
import nl.volleyplanner.web.controller.authorization.LoginController

class AuthRouteGuard(val minAuthLevel: AuthLevel) : RouteGuard {
    override suspend fun canActivate(context: PageRouteContext): RouteGuardResult {
        val user = AuthContextService.authUser
        if ((user?.authLevel ?: AuthLevel.AnonymousPublic) >= minAuthLevel) {
            return RouteGuardResult.Allow
        } else if (user == null || user.authLevel == AuthLevel.AnonymousPublic) {
            // No user or anonymous token. Redirect to login
            return RouteGuardResult.Deny { LoginController() }
        } else {
            // No access for user: Forbidden
            return RouteGuardResult.Deny { ForbiddenController() }
        }
    }
}